import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { transparentize } from 'polished';
import Background250x250 from './img/bg-250-250.jpg';
import Background250x250HiDPI from './img/bg-250-250@2x.jpg';
import Background300x250 from './img/bg-300-250.jpg';
import Background300x250HiDPI from './img/bg-300-250@2x.jpg';
import Background300x400 from './img/bg-300-400.jpg';
import Background300x400HiDPI from './img/bg-300-400@2x.jpg';
import Background300x600 from './img/bg-300-600.jpg';
import Background300x600HiDPI from './img/bg-300-600@2x.jpg';
import Background320x480 from './img/bg-320-480.jpg';
import Background320x480HiDPI from './img/bg-320-480@2x.jpg';
import Background800x250 from './img/bg-800-250.jpg';
import Background800x250HiDPI from './img/bg-800-250@2x.jpg';
import Background970x250 from './img/bg-970-250.jpg';
import Background970x250HiDPI from './img/bg-970-250@2x.jpg';

type BackgroundAsset = string | { src: string };

const getBackgroundImageUrl = (asset: BackgroundAsset): string =>
  typeof asset === 'string' ? asset : asset.src;

const sizes = [
  {
    image: Background250x250,
    image2x: Background250x250HiDPI,
    media: '(max-width: 250px) and (max-height: 250px)',
  },
  {
    image: Background300x250,
    image2x: Background300x250HiDPI,
    media: '(min-width: 251px) and (max-width: 300px) and (max-height: 250px)',
  },
  {
    image: Background300x400,
    image2x: Background300x400HiDPI,
    media:
      '(min-width: 251px) and (min-height: 251px) and (max-width: 300px) and (max-height: 400px)',
  },
  {
    image: Background320x480,
    image2x: Background320x480HiDPI,
    media: '(min-width: 301px) and (max-width: 320px) and (max-height: 480px)',
  },
  {
    image: Background300x600,
    image2x: Background300x600HiDPI,
    media:
      '(min-width: 251px) and (min-height: 401px) and (max-width: 300px) and (max-height: 600px)',
  },
  {
    image: Background800x250,
    image2x: Background800x250HiDPI,
    media: '(min-width: 321px) and (max-width: 800px)',
  },
  {
    image: Background970x250,
    image2x: Background970x250HiDPI,
    media: '(min-width: 801px) and (max-width: 970px)',
  },
];

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  background-repeat: no-repeat;
  background-size: cover;

  ${() =>
    sizes.map(
      ({ image, image2x, media }) => css`
        /* stylelint-disable-next-line media-query-no-invalid */
        @media ${media} {
          background-image: url('${getBackgroundImageUrl(image)}');

          @media (min-resolution: 2dppx) {
            background-image: url('${getBackgroundImageUrl(image2x)}');
          }
        }
      `,
    )}

  @media (min-width: 780px) {
    flex-direction: row-reverse;
  }
`;

const LogoWrapper = styled.div`
  position: relative;
`;

const Logo = styled.span`
  display: inline-flex;
  margin: 0.3125rem 0.625rem;
  fill: ${({ theme }) => theme.colors.brand.green100};

  @media (min-height: 400px) or (min-width: 800px) {
    position: absolute;
    left: 0;
    bottom: 1rem;
    margin: 0;
    padding: 0.25rem 0.625rem;
    background-color: ${({ theme }) =>
      transparentize(0.27, theme.colors.neutral.white100)};
  }
`;

export { Wrapper, LogoWrapper, Logo };
